import React from "react";
import { useTranslation } from "react-i18next";

function LanguageSwitch() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div>
      <button onClick={() => changeLanguage("en")}>English</button>
      <button onClick={() => changeLanguage("kor")}>Korean</button>
      {/* Add more buttons for other languages if needed */}
    </div>
  );
}

export default LanguageSwitch;
